// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout-module_layout-uWGwr{display:flex;height:100vh}.Layout-module_content-cFD4Y{flex:1;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./widgets/Layout/ui/Layout.module.sass"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,YAAA,CACF,6BACE,MAAA,CACA,eAAA","sourcesContent":[".layout\n  display: flex\n  height: 100vh\n.content\n  flex: 1\n  overflow-y: auto\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `Layout-module_layout-uWGwr`,
	"content": `Layout-module_content-cFD4Y`
};
export default ___CSS_LOADER_EXPORT___;
